<template>
  <div
    :class="rootClasses"
  >
    <div class="messenger-message__person">
      <div class="messenger-message-avatar">
        <vx-tooltip :text="avatarInfo.text">
          <vs-avatar
            size="40px"
            style="margin: 0"
            :src="avatarInfo.src"
            :text="avatarInfo.text"
          />
        </vx-tooltip>
      </div>
    </div>
    <div class="messenger-message__text">
      <div class="messenger-message-balloon">
        <message-text
          v-if="message.message_type === 'text'"
          :text="message.body"
        />

        <message-location
          v-if="message.message_type === 'location'"
          :address="message.additional_data['location.address']"
          :longitude="parseFloat(message.additional_data['location.longitude'])"
          :latitude="parseFloat(message.additional_data['location.latitude'])"
        />

        <message-image
          v-if="message.message_type === 'image'"
          :file="message.file"
        />

        <message-file
          v-if="message.message_type === 'file'"
          :file="message.file"
        />
      </div>
      <div class="messenger-message-info">
        <span class="messenger-message-info__date">
          <messenger-date
            :date="message.created_at"
          />
        </span>
        <span class="messenger-message-info__status">
          <vs-icon
            v-if="message.delivered"
            class="message-status__icon"
            icon="done_all"
          />
          <vs-icon
            v-else
            class="message-status__icon"
            icon="done"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import MessengerDate from '../../../components/MessengerDate.vue'
import MessageText from './types/MessageText.vue'
import MessageLocation from './types/MessageLocation.vue'
import MessageImage from './types/MessageImage.vue'
import MessageFile from './types/MessageFile.vue'

export default {
  components: {
    MessengerDate,
    MessageText,
    MessageLocation,
    MessageImage,
    MessageFile
  },

  props: {
    message: {
      type: Object,
      required: true
    },
    transportType: {
      type: String,
      required: true
    }
  },

  computed: {
    avatarInfo () {
      const data = {}
      if (this.message.sender_type === 'bot') {
        data.src = require('@/assets/images/bot-avatar.png')
        data.text = 'Bot'
      } else if (this.message.sender_type === 'bulk_delivery') {
        data.src = require('@/assets/images/bot-avatar.png')
        data.text = 'Рассылка'
      } else if (this.message.sender_type === 'operator') {
        data.src = this.message.operator.profile_image_url
        data.text = this.message.operator.name
      } else if (this.message.sender_type === 'client') {
        data.src = this.message.client.profile_image_url
        data.text = this.message.client.name
      }
      return data
    },
    rootClasses () {
      return {
        'messenger-message': true,
        'messenger-message--operator': !['bulk_delivery', 'client'].includes(this.message.sender_type),
        'messenger-message--bulk-delivery': this.message.sender_type === 'bulk_delivery',
        'messenger-message--delivered': this.message.delivered,
        'messenger-message--viewed': this.message.viewed
      }
    }
  }
}
</script>
